import React from "react";
import TailormedLogoIcon from "../assets/svg/MainLogoIcon";
import { Layout as AntLayout } from "antd";
import styled from "styled-components";
import { GREEN } from "../constant/colors";

const { Header: AntHeader } = AntLayout;

const Header = styled(AntHeader)`
  background-color: ${GREEN};
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 64px;
`;

const TailormedLogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TailormedHeaderText = null;
const TailormedVisualIcon = null;

const AppLayout = ({ children }) => {
  return <Header>{children}</Header>;
};

const ErrorPageLayout = ({ children }) => <div>{children}</div>;

export {
  ErrorPageLayout,
  AppLayout,
  TailormedLogoIcon,
  LogoContainer,
  TailormedVisualIcon,
  TailormedHeaderText,
  TailormedLogoContainer
};
